import {api} from '_api';

import type {Desk} from "_types/models/Desk";
import type {Finder, Mutator, Searcher} from '_types/swr';
import type {NoContent, Paginated} from "_types/aspnet";
import type {DeskStore, DeskUpdate} from "_types/requests/desk";

import {unwrap} from '_utils/axios';
import {parseKey, parseSearcherKey} from '_utils/swr';

export const searchDesks: Searcher<Paginated<Desk>> = async ({queryKey}) => {
    const url = parseSearcherKey(queryKey);
    const response = await api.get<Paginated<Desk>>(url);

    return await unwrap(response);
};

export const findDesk: Finder<Desk> = async ({queryKey}) => {
    const url = parseKey(queryKey);
    const response = await api.get<Desk>(url);

    return await unwrap(response);
};

export const storeDesk: Mutator<Desk, DeskStore> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<Desk>(url, payload);

    return await unwrap(response);
};

export const updateDesk: Mutator<Desk, DeskUpdate> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.patch<Desk>(url, payload);

    return await unwrap(response);
};

export const deleteDesk: Mutator<NoContent> = async (queryKey) => {
    const url = parseKey(queryKey);

    return await api.delete<NoContent>(url);
};
